import styled from 'styled-components'

import { InputLabel } from '@syconium/little-miss-figgy'

export const AccountLinkText = styled.span`
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
`

export const AccountLinkTextWrapper = styled.div`
  display: inline;
  border-bottom: 2px solid ${o => o.theme.color.stroke.neutral.text.primary.on.background};
`

export const OrderLookupFormText = styled(InputLabel)`
  display: flex;
  justify-content: left;
  font-weight: bold;
  font-size: 13px;
  line-height: 20px;
  letter-spacing: 2px;
  text-transform: uppercase;
`
